import { c as _c } from "react/compiler-runtime";
import { useNextApiSubscription } from '@newfront-insurance/next-api-swr';
import type { NextApiSubscription } from '@newfront-insurance/next-api-swr';
import { useProvider } from '@newfront-insurance/react-provision';
import type { SWRConfiguration } from 'swr';
import { routes } from '../../bff/routes';
import type { Employee } from '../../bff/types';
import { LayoutConfigProvider } from '../config';
export function useOperationsEmployees(config) {
  const $ = _c(2);
  const {
    apiBasePath: basePath
  } = useProvider(LayoutConfigProvider);
  let t0;
  if ($[0] !== basePath) {
    t0 = routes.getOperationsEmployees.getUrl({
      basePath
    });
    $[0] = basePath;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useNextApiSubscription(t0, config);
}